import { Api } from '../api';
import { payments } from '../endpoints';
import type { ApiPaginate, ApiResponse, FileResponse } from '../../models';
import type {
  GetDepositPaymentsByAccountsRequest,
  GetDepositPaymentsByRecipientIdRequest,
  GetDepositPaymentsResponse,
  GetPaymentsByRecipientIdResponse,
  ValidateIbanResponse,
} from './models';

export class PaymentApi extends Api {
  static getPaymentById = (request: string, signal?: AbortSignal) =>
    this.get<ApiResponse<GetDepositPaymentsResponse>>({ url: payments.getPaymentById(), queryParams: { id: request }, signal });

  static getPaymentsByAccounts = (request: GetDepositPaymentsByAccountsRequest, signal?: AbortSignal) =>
    this.get<ApiPaginate<GetDepositPaymentsResponse[]>>({ url: payments.getPaymentsByAccounts(), queryParams: request, signal });

  static getPaymentsByRecipientId = (request: GetDepositPaymentsByRecipientIdRequest, signal?: AbortSignal) =>
    this.get<ApiResponse<{ data: GetPaymentsByRecipientIdResponse[]; total: number }>>({
      url: payments.getPaymentsByRecipientId(),
      queryParams: request,
      signal,
    });

  static getGenerateReceiptById = (id: string, signal?: AbortSignal) =>
    this.get<FileResponse>({ url: payments.getGenerateReceiptById(), queryParams: { id }, signal });

  static generateOutgoingPayment = (id: string, signal?: AbortSignal) =>
    this.get<FileResponse>({ url: payments.generateOutgoingPayment(id), queryParams: { documentType: 'Pdf' }, signal });

  static validateIban = (iban: string, signal?: AbortSignal) =>
    this.get<ApiResponse<ValidateIbanResponse>>({ url: payments.validateIban(iban), signal });
}
